// extracted by mini-css-extract-plugin
export default {"QRCodePopup":"QRCodeopup_QRCodePopup__aZtSq","CloseButtonContainer":"QRCodeopup_CloseButtonContainer__Yg4ne","ContinueButton":"QRCodeopup_ContinueButton__WUmZS"};